import { FC, MouseEvent } from 'react'
import { Divider, MaxValue, MinValue, Wrapper } from './Suggestion.styles'
import { compactNumber } from '@/core/utils/compactNumber.ts'

interface Props {
  min: number | null
  max: number | null
  onChange: (value: number) => void
}

const Suggestion: FC<Props> = ({ min, max, onChange }) => {
  const onWrapperClick = (event: MouseEvent) => {
    event.stopPropagation()
  }

  const hasMin = min !== null
  const hasMax = max !== null

  return (
    <Wrapper onClick={onWrapperClick}>
      {hasMin && (
        <MinValue variant="text" onClick={() => onChange(min)}>
          {compactNumber(min)}
        </MinValue>
      )}

      {hasMin && hasMax && <Divider />}

      {hasMax && (
        <MaxValue variant="text" onClick={() => onChange(max)}>
          {compactNumber(max)}
        </MaxValue>
      )}
    </Wrapper>
  )
}

export default Suggestion
